export const COLLECTION_TYPE = {
  EPISODE_COLLECTION: 'episodeCollection',
  CLIP_COLLECTION: 'clipCollection',
  SERIES_COLLECTION: 'seriesCollection',
  MOVIE_COLLECTION: 'movieCollection',
  PORTRAIT_COLLECTION: 'portraitCollection'
} as const;
